import { RouteObject } from "react-router-dom";
import QuestionsLayout from "src/layouts/QuestionsLayout";
import { Matches } from "../matches";
import Questions from "src/pages/Questions";
import { Paths } from "../paths";
import CancellationLayout from "src/layouts/CancellationLayout";
import SubscriptionProvider from "src/context/SubscriptionProvider";

export const cancellationRoutes: RouteObject[] = [
  {
    path: Matches.SUBSCRIPTION_ID,
    element: (
      <SubscriptionProvider>
        <CancellationLayout />
      </SubscriptionProvider>
    ),
    children: [
      {
        path: Paths.CANCELLATION,
        element: <QuestionsLayout />,
        children: [
          {
            path: Matches.QUESTION_ID,
            element: <Questions />,
          },
        ],
      },
    ],
  },
];
